"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextView = void 0;
const react_1 = __importStar(require("react"));
const axios_1 = __importDefault(require("axios"));
const prop_types_1 = __importDefault(require("prop-types"));
const TextView = (props) => {
    // constructor(props){
    //   super(props)
    //   this.getText = this.getText.bind(this)
    //   this.highlightTextRange = this.highlightTextRange.bind(this)
    //   this.state = {
    //     text: ""
    //   }
    // }
    const [text, setText] = (0, react_1.useState)("");
    const [highlightedText, setHighlightedText] = (0, react_1.useState)("");
    (0, react_1.useEffect)(() => {
        getText(props.tresourceid);
    }, [props.tresourceid]);
    (0, react_1.useEffect)(() => {
        setHighlightedText(highlightTextRange(text, props.start, props.stop, props.context));
    }, [text, props.start, props.stop, props.context]);
    const getText = (tresourceid) => {
        axios_1.default.get("https://exist.scta.info/exist/apps/scta-app/csv-pct.xq?resourceid=" + tresourceid).then((d) => {
            const text = d.data.trim();
            //setText(this.highlightTextRange(text, this.props.start, this.props.stop, this.props.context))
            setText(text);
        });
    };
    const highlightTextRange = (text, start, stop, context) => {
        if (start && stop) {
            const wordTokenStart = start;
            const wordTokenEnd = stop;
            const wordTokens = text.split(" ");
            const wordTokensClean = wordTokens.filter(Boolean);
            const wordTokensBefore = wordTokensClean.slice(0, wordTokenStart - 1);
            const wordTokensAfter = wordTokensClean.slice(wordTokenEnd);
            const wordTokensFocus = wordTokensClean.slice(wordTokenStart - 1, wordTokenEnd);
            let textElement = "";
            if (context) {
                textElement = "<p class='text'><span>" + wordTokensBefore.join(" ") + "</span> <span style='font-weight: bold'>" + wordTokensFocus.join(" ") + "</span> <span>" + wordTokensAfter.join(" ") + "</span></p>";
            }
            else {
                textElement = "<p class='text'>" + wordTokensFocus.join(" ") + "</p>";
            }
            return textElement;
        }
        else {
            return "<p class='text'>" + text + "</p>";
        }
    };
    return (react_1.default.createElement("div", { className: props.hidden ? "hidden" : "showing" }, highlightedText && react_1.default.createElement("p", { dangerouslySetInnerHTML: { __html: highlightedText } })));
};
exports.TextView = TextView;
// Set default props
exports.TextView.defaultProps = {
    hidden: false,
    context: true,
};
exports.TextView.propTypes = {
    /**
    * the Url for the transcription resource
    **/
    tresourceid: prop_types_1.default.string.isRequired,
    /**
    * optional word start token number
    **/
    start: prop_types_1.default.number,
    /**
    * optional word stop token number
    **/
    stop: prop_types_1.default.number,
    /**
    * optional showContext around start and stop words
    **/
    context: prop_types_1.default.bool,
    /**
    * optional hidden
    **/
    hidden: prop_types_1.default.bool
};
//# sourceMappingURL=text-view.js.map